var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"gc-popup__body-content",attrs:{"id":"gc-popup-body-content"}},[_vm._t("default"),_c('div',{staticClass:"gc-popup_body-static-bottom"})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }